import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Row,
} from 'reactstrap';
import { addAction } from '../actions/BoxSessionLogging';
import MultiInputNumber from './MultiInputNumber';

const AddPRINumber = ({ isOpen, onCancel, onConfirm, importNumberList }) => {
  const dispatch = useDispatch();
  const [portingNumbersArray, setPortingNumbersArray] = useState([]);
  const onNumberssChange = e => {
    setPortingNumbersArray(e);
  };
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>PRI Porting Numbers</ModalHeader>
      <ModalBody>
        <div className="container">
          <FormGroup row>
            <Label for="name" sm={4}>
              Numbers:
            </Label>
            <Col md={12} sm={9}>
              <MultiInputNumber
                placeholder="Enter the number"
                inputData={portingNumbersArray}
                onChange={onNumberssChange}
              />
            </Col>
          </FormGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          outline
          onClick={() => {
            setPortingNumbersArray([]);
            onCancel();
          }}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => {
            importNumberList(portingNumbersArray);
            onConfirm();
            setPortingNumbersArray([]);
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddPRINumber;
